export const gradients = {
  mainGradient: 'linear-gradient(94.96deg, #F26BCD 8.93%, #C567F4 94.95%);',
}

export const gradientBackground = `
  background: -webkit-${gradients.mainGradient};
  background: -moz-${gradients.mainGradient};
  background: -o-${gradients.mainGradient};
  background: ${gradients.mainGradient}
`

export const gradientBackgroundText = `
  ${gradientBackground};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent
`
